import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
} from "antd";
import "../../crmSharedStyle.css";


const STATUS_COLORS = [
  "blue",
  "green",
  "red",
  "orange",
  "purple",
  "magenta",
  "volcano",
  "gold",
  "lime",
  "cyan",
  "geekblue",
  "pink",

  "processing",
  "success",
  "warning",
  "error",

  "#1677ff",
  "#13c2c2",
  "#52c41a",
  "#fa8c16",
  "#722ed1",
  "#eb2f96",
  "#a0d911",
  "#fa541c",
  "#2f54eb",
  "#389e0d",
];

const MasterModal = ({
  open,
  onClose,
  onSubmit,
  editing,
  type,
}) => {
  const [form] = Form.useForm();

  // Keyed on `open` too, not just `editing` -- clicking "Add" repeatedly
  // leaves `editing` at `null` both times (no change), so an effect keyed
  // on `editing` alone never re-fires on the second open and the form kept
  // showing whatever was typed into it the first time.
  useEffect(() => {
    if (!open) return;
    if (editing) {
      form.setFieldsValue(editing);
    } else {
      form.resetFields();
    }
  }, [open, editing, form]);

  return (
    <Modal
      open={open}
      title={
        editing
          ? `Edit ${type}`
          : `Add ${type}`
      }
      onCancel={onClose}
      onOk={() => form.submit()}
      okText={editing ? "Update" : "Create"}
      className="crm-modal-responsive"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Required",
            },
          ]}
        >
          <Input />
        </Form.Item>

        {type === "Status" && (
          <Form.Item
            label="Color"
            name="color"
            initialValue="blue"
          >
            <Select
            options={STATUS_COLORS.map((c) => ({
              label: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      width: 14,
                      height: 14,
                      borderRadius: "50%",
                      background: c,
                    }}
                  />

                  <span
                    style={{
                      textTransform: "capitalize",
                    }}
                  >
                    {c}
                  </span>
                </div>
              ),

              value: c,
            }))}
          />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default MasterModal;